module.exports = __webpack_public_path__ + "static/media/userAvatar-placeholder.bbd2208b.svg";